import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDgK0G2WQVtxy0wVlr_eQsiGisPXNi3qdI",
  authDomain: "powdermaps-a09d6.firebaseapp.com",
  projectId: "powdermaps-a09d6",
  storageBucket: "powdermaps-a09d6.firebasestorage.app",
  messagingSenderId: "1020755052649",
  appId: "1:1020755052649:web:72fdd3d3de6a030e66baf8",
  measurementId: "G-CJ94F45EBH"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
